module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "nav"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-dense"
  }, [_c('h3', {
    staticClass: "md-title title",
    on: {
      "click": _vm.home
    }
  }, [_vm._v("JSON Schema Editor")]), _vm._v(" "), _c('md-button', {
    class: [_vm.isPath('/index.html') || _vm.isPath('/') ? _vm.active : ''],
    nativeOn: {
      "click": function($event) {
        return _vm.about($event)
      }
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('md-button', {
    class: [_vm.isPath('/guide.html') ? _vm.active : ''],
    nativeOn: {
      "click": function($event) {
        return _vm.guide($event)
      }
    }
  }, [_vm._v("Guide")]), _vm._v(" "), _c('md-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.editor($event)
      }
    }
  }, [_vm._v("Editor")]), _vm._v(" "), _c('md-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.jsonEditor($event)
      }
    }
  }, [_vm._v("JSON Editor")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('md-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.github($event)
      }
    }
  }, [_c('md-icon', {
    attrs: {
      "md-iconset": "fa fa-github"
    }
  })], 1), _vm._v(" "), (!_vm.isSignIn) ? _c('md-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.signIn($event)
      }
    }
  }, [_vm._v("Sign In")]) : _vm._e(), _vm._v(" "), (!_vm.isSignIn) ? _c('md-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.signUp($event)
      }
    }
  }, [_vm._v("Sign Up")]) : _vm._e(), _vm._v(" "), (_vm.isSignIn) ? _c('md-menu', {
    attrs: {
      "md-align-trigger": ""
    }
  }, [_c('md-button', {
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_vm._v("My Account")]), _vm._v(" "), _c('md-menu-content', [_c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.signOut($event)
      }
    }
  }, [_vm._v("Sign Out")]), _vm._v(" "), _c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.changePassword($event)
      }
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.deleteAccount($event)
      }
    }
  }, [_vm._v("Delete Account")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-dialog', {
    ref: "deleteAccountDialog"
  }, [_c('md-dialog-title', [_vm._v("Delete Account")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n      Are you sure to delete your account?"), _c('br'), _vm._v("\n      All your stored schemas would be lost!\n    ")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.deleteAccountCanceled($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.deleteAccountConfirmed($event)
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16055fcb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Nav.vue
// module id = 707
// module chunks = 2